export default __webpack_public_path__ + "static/media/fb.53d741fa.svg";